<template>
  <page-list
    :list="list"
    :columns="changedColumns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :showGroupActions="showGroupActions"
    :export-data-options="exportDataOptions"
    hiddenPin>
    <template v-slot:group-actions-append>
      <date-time
        class="ml-2"
        :getParams.sync="dateParam"
        :dateMode.sync="dateMode"
        paramTimeFormatter="YYYY-MM-DDTZ"
        showStartMonthTip
        @refresh="fetchData" />
      <fixed-label-filter class="ml-2" :label="$t('common_112')">
        <base-select
          v-model="tagKey"
          :options="tagOptions"
          filterable
          version="v1"
          minWidth="140px"
          :select-props="{ placeholder: $t('common_605') }" />
      </fixed-label-filter>
    </template>
    <template v-slot:table-prepend>
      <total-price :currencySign="currencySign" :total="total_amount" :secondary_total="total_secondary_amount" setSecondaryToAmount />
    </template>
  </page-list>
</template>

<script>
import * as R from 'ramda'
import TotalPrice from '@Bill/sections/TotalPrice'
import currencyRequest from '@Bill/mixins/currencyRequest'
import TotalPriceMixin from '@Bill/mixins/totalPrice'
// import { getDescriptionFilter } from '@/utils/common/tableFilter'
import { getAmountColumns } from '@Bill/utils'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'CloudDomainList',
  components: {
    TotalPrice,
  },
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, currencyRequest, TotalPriceMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
    cloudEnv: String,
    isAllowCreate: {
      type: Boolean,
      default: true,
    },
    hiddenActions: {
      type: Array,
      default: () => ([]),
    },
    billShared: Boolean,
    projectShared: Boolean,
  },
  data () {
    return {
      batchDeleteBill: true,
      dateMode: 'month',
      dateParam: {},
      tagKey: '',
      tagOptions: [],
      list: this.$list.createList(this, {
        id: this.id,
        idKey: 'name',
        exportUseIdKey: true,
        apiVersion: 'v1',
        resource: 'bill_tags',
        getParams: this.getParam,
        fetchDataCb: this.getTotal,
        noPreLoad: true,
        filterOptions: {
          // name: {
          //   label: this.$t('common_112'),
          //   filter: true,
          //   formatter: val => {
          //     return `key.contains('${val}')`
          //   },
          // },
          value_word: {
            label: this.$t('table.title.name'),
            // formatter: val => {
            //  return `value.contains('${val}')`
            // },
          },
        },
      }),
    }
  },
  computed: {
    changedColumns () {
      const columns = R.clone(this.columns)
      const amountColumns = getAmountColumns({
        disable_cost_conversion: this.currencyParams.disable_cost_conversion,
        dateMode: this.dateMode,
        monthSortable: false,
        currencySign: this.currencySign,
        fieldMonth: 'month_amount',
      })
      return [...columns, ...amountColumns]
    },
    exportDataOptions () {
      const items = this.changedColumns.map(item => {
        return {
          key: item.field,
          label: item.title,
        }
      })
      return {
        items: [
          {
            field: 'key',
            title: this.$t('common_112'),
            formatter: ({ row }) => {
              return row.key
            },
          },
          ...items,
        ],
      }
    },
    tagParams () {
      const params = {
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
        scope: this.$store.getters.scope,
        key_only: true,
        is_prepaid_amortizing: this.billShared,
        is_project_sharing: this.projectShared,
        ...this.currencyParams,
      }
      if (this.dateParam.start_date) {
        params.start_day = this.$moment(this.dateParam.start_date.replace('TZ', '')).format('YYYYMMDD')
        params.end_day = this.$moment(this.dateParam.end_date.replace('TZ', '')).format('YYYYMMDD')
      }
      return params
    },
  },
  watch: {
    currencyParams: {
      handler: function () {
        this.fetchData()
      },
      deep: true,
    },
    billShared () {
      this.fetchData()
    },
    projectShared () {
      this.fetchData()
    },
    tagKey () {
      this.fetchData()
    },
    tagParams: {
      handler: function () {
        this.fetchTags()
      },
      immediate: true,
    },
  },
  created () {
    this.initSidePageTab('overview')
    this.fetchData()
  },
  methods: {
    async fetchTags () {
      try {
        const res = await new this.$Manager('res_tag_details').list({
          params: this.tagParams,
        })
        const tags = this.tagMapper(res.data.data)
        this.tagOptions = tags
        if (!tags.length) {
          this.tagKey = ''
        } else if (this.tagKey) {
          const targets = tags.filter(item => item.id === this.tagKey)
          if (!targets.length) {
            this.tagKey = tags[0].id
          }
        } else {
          this.tagKey = tags[0].id
        }
        console.log(res)
      } catch (err) {
        throw err
      }
    },
    fetchData () {
      if (!this.tagKey) return
      this.list.fetchData()
    },
    getParam () {
      const ret = {
        // query_type: 'tag_stat',
        start_date: this.$moment().startOf('month').format('YYYY-MM-DD') + 'TZ',
        end_date: this.$moment().endOf('month').format('YYYY-MM-DD') + 'TZ',
        ...this.currencyParams,
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        ...this.dateParam,
        details: true,
      }
      if (this.billShared) {
        ret.is_prepaid_amortizing = true
      } else {
        ret.is_prepaid_amortizing = false
      }
      if (this.projectShared) {
        ret.is_project_sharing = true
      } else {
        ret.is_project_sharing = false
      }
      ret.key = this.tagKey
      return ret
    },
    tagMapper (list) {
      const maps = {}
      list.forEach(item => {
        if (item.key.startsWith('ext:') || item.key.startsWith('user:')) {
          const key = item.key.startsWith('user:') ? item.key.replace('user:', '') : item.key
          maps[item.key] = {
            tag_cost: item.tag_cost,
            name: key,
            id: item.key,
          }
        }
      })
      const ret = Object.values(maps)
      // ret.sort((a, b) => a.name.localeCompare(b.name))
      ret.sort((a, b) => {
        if (b.tag_cost !== a.tag_cost) {
          return b.tag_cost - a.tag_cost
        }
        return a.name.localeCompare(b.name)
      })
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillTagSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
        dateParam: this.dateParam,
        dateMode: this.dateMode,
      }, {
        list: this.list,
        hiddenActions: this.hiddenActions,
      })
    },
  },
}
</script>
